import 'broadcastchannel-polyfill';
import dayjs from 'dayjs';
import { ctiday } from './utils/cti-day';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import flatpickr from 'flatpickr';
import { Japanese } from 'flatpickr/dist/l10n/ja';
import 'flatpickr/dist/flatpickr.min.css';
import { closeConfirm, closeConfirmWithOK, openConfirm } from './components/kf-confirm';
import { openAlert } from './components/kf-alert';
import '@simonwep/pickr/dist/themes/nano.min.css';
const locale = {
  name: 'ja',
  weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
  weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
  weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
  months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
  ordinal: n => `${n}日`,
  relativeTime: {
    future: '%s後',
    past: '%s前',
    s: '数秒',
    m: '1分',
    mm: '%d分',
    h: '1時間',
    hh: '%d時間',
    d: '1日',
    dd: '%d日',
    M: '1ヶ月',
    MM: '%dヶ月',
    y: '1年',
    yy: '%d年'
  }
};

dayjs.locale(locale, null, true);
dayjs.locale('ja');
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

flatpickr.localize(Japanese);
flatpickr.l10ns.default.firstDayOfWeek = 1;

window.openConfirm = openConfirm;
window.closeConfirm = closeConfirm;
window.closeConfirmWithOk = closeConfirmWithOK;
window.openAlert = openAlert;
window.dayjs = dayjs;
window.ctiday = ctiday;